export const formatMoney = (
  amount: number,
  locale = 'de-DE',
  currency = 'EUR',
  maximumFractionDigits = 0,
  options: Intl.NumberFormatOptions = {}
) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: maximumFractionDigits,
    maximumFractionDigits,
    ...options,
  }).format(amount)

export const formatPriceAmount = (
  amount: number,
  locale: string,
  currency: string | undefined = undefined,
  maximumFractionDigits = 2,
  options: Intl.NumberFormatOptions = {}
) => formatMoney(amount / 100, locale, currency, maximumFractionDigits, options)

/**
 * Formats a price in cents, automatically hiding decimals for whole numbers.
 * e.g. 5900 → "€59", 5990 → "€59,90"
 */
export const formatSmartPriceAmount = (
  amountInCents: number,
  locale: string,
  currency: string | undefined = undefined
) =>
  formatPriceAmount(
    amountInCents,
    locale,
    currency,
    amountInCents % 100 === 0 ? 0 : 2
  )

/**
 * Formats a raw monetary amount (not cents), automatically hiding decimals for whole numbers.
 * e.g. 59.0 → "€59", 59.9 → "€59,90"
 */
export const formatSmartMoney = (
  amount: number,
  locale: string,
  currency: string
) => formatMoney(amount, locale, currency, Number.isInteger(amount) ? 0 : 2)
